//import { addressToogler } from './form-helpers';
//import { addressForm } from '../../types/types';

// const addAddress = () => {
//   addressToogler();
// }

// const submitAddress = () => {
//   if(!addressForm.addressForm) return;

//   addressForm.addressForm.addEventListener('submit', e => {
//     if(addressForm.addressForm.checkValidity()) {
//       e.preventDefault();
//       addressForm.addressForm.classList.remove('was-validated');
//       addressForm.addressForm.classList.remove('form-control:valid');

//       let jsonData = JSON.stringify({
//         addressOne: addressForm.addressOne.value,
//         addressTwo: addressForm.addressTwo.value,
//         addressCity: addressForm.addressCity.value,
//         addressState: addressForm.addressState.dataset.value,
//         addressZip: addressForm.addressZip.value
//       });

//       console.log(jsonData);

//     } else {
//       e.preventDefault();
//       e.stopPropagation();
//       addressForm.addressForm.classList.add('was-validated');
//       //addressForm.addressDropDown.classList.add('invalid-input');
//     }
//   });
// }

//export { submitAddress };